
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { UserCountVm } from "@/interfaces/UserCountVm";

@Component
export default class UserCount extends Vue {
  counts: UserCountVm[] = [];

  // $refs!: {};

  headers = [
    { text: "Datum", value: "date",sortable: true },
    { text: "Angelegte Anwender", value: "lastDayOfMonthCount",sortable: true },
    { text: "Active Anwender", value: "activeDuringMonthCount", sortable: true },
  ];

  mounted() {
    this.updateCounts();
  }

  async onSearchChanged() {
    await this.updateCounts();
  }

  async updateCounts() {
    this.counts = await rest.url("admin/getUserCounts").get();
  }
}
